import { Link } from "react-router-dom";
import { Hash } from "lucide-react";

/* TopicLink — NewsLayer topical search navigation. Distinct contract from
   EntityLink: a TopicLink NEVER implies an Entity Page exists (hash mark,
   no entity logo, purple accent). Use ONLY where the content model identifies
   the value as a topic/search concept — never as a fallback for a non-live
   canonical entity (Rule 6: those stay inert). */
export const TopicLink = ({ topic, className = "" }: { topic: string; className?: string }) => (
  <Link to={`/search?q=${encodeURIComponent(topic)}`}
    data-testid={`topic-link-${topic.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    aria-label={`Search NewsLayer for ${topic}`}
    className={`inline-flex items-center gap-1.5 rounded-full border border-white/[0.12] bg-white/[0.04] px-2.5 py-1 text-[12px] font-semibold text-gray-300 hover:border-[#A78BFA]/50 hover:text-white transition-colors capitalize focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#A78BFA]/60 ${className}`}>
    <Hash aria-hidden className="h-3 w-3 text-[#A78BFA] shrink-0" />
    {topic}
  </Link>
);
